import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "CivicHearth — A street that looks after itself.";
const PRODUCTION_ORIGIN = "https://civichearth.com";

export const Seo = ({ title, description, image }) => {
  const full = title ? `${title} · CivicHearth` : DEFAULT_TITLE;
  const { pathname } = useLocation();
  const canonical = `${PRODUCTION_ORIGIN}${pathname || "/"}`;
  // Per-page OG artwork with a site-wide default. index.html ships static
  // fallbacks for no-JS crawlers (WhatsApp/Meta), marked data-rh="true".
  const ogImage = image || `${PRODUCTION_ORIGIN}/og-image.png`;
  // De-dup (review fix, 2026-02): React 19 hoists <meta> children natively,
  // BYPASSING react-helmet-async's data-rh reconciliation — the static
  // index.html defaults were never removed and every tag rendered twice.
  // So we retire the static ones ourselves the moment per-page tags exist;
  // helmet/React-hoisted tags don't carry data-rh in this path, so only the
  // index.html defaults match. No-JS crawlers still see the full defaults.
  useEffect(() => {
    document.head.querySelectorAll('meta[data-rh="true"]').forEach((el) => el.remove());
  }, []);
  return (
    <Helmet>
      <title>{full}</title>
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={full} />
      <meta property="og:url" content={canonical} />
      {description && <meta name="description" content={description} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
